import React from "react";
import TooltipCustom from "../tooltipCustom";

import inIcon from "../../../assets/image/icons/tables/in.svg";
import linkSvgGold from "../../../assets/image/icons/tables/goldLink.svg";
import avatarSvg from "../../../assets/image/icons/svg/user.svg";

import "./style.scss";
import { ordinalNumber } from "../../../shared/utils";

const CustomCellRenderer = ({ data }) => {
  return (
    <div className="name-container">
      <img
        className="avatar"
        src={data.contact.avatar ? data.contact.avatar : avatarSvg}
        alt="avatar"
      />

      <div className="column-title">{data.contact.fullName}</div>

      {data.contact.connection && (
        <div className="connection">
          <p>•</p>
          <div className="text-table-users">
            {ordinalNumber(data.contact.connection)}
          </div>
        </div>
      )}
      <div className="account-container-text">
        {data.contact.account ? <img src={inIcon} alt={"premium"} /> : <></>}
        <div
          className="link-container-ln"
          target="_blank"
          rel="noopener noreferrer"
          href="#"
          onClick={async (e) => {
            e.preventDefault();
            await data.contact.openLinkedInProfile();
          }}
        >
          <TooltipCustom title="Open LinkedIn profile" arrow={true}>
            <img src={linkSvgGold} alt="link svg" />
          </TooltipCustom>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CustomCellRenderer);
